<template>
  <div class="home">
    <!-- hidden-xs-only(PC)    hidden-sm-and-up (mobile) -->
    <swiper id="swiperBox" :options="swiperOption" ref="indexSwiper" @slideChange="slideChange" class="hidden-xs-only">
      <swiper-slide class="swiper-slide banner">
        <el-carousel trigger="click" indicator-position="none" autoplay>
          <el-carousel-item >
            <router-link :to="{path:'/year20'}"  >
             <img src="../../assets/img/year20/banner20.jpg" />
              <div class="banner-text">
                <div class="container" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
                  <div class="banner-btn">
                    <el-button type="primary" plain>{{$t("home.banner.year20")}}</el-button>
                  </div>
                </div>
              </div>
            </router-link>
          </el-carousel-item>
          <el-carousel-item v-for="(item,index) in bannerLists" :key="index">
            <!-- muted：静音播放视频。 playsinline属性则用于防止视频在移动设备上全屏播放-->
            <video width="100%" height="100%" preload="metadata" autoplay muted playsinline loop v-if="item.picturePath.slice(item.picturePath.length-4)=='.mp4'" style="object-fit:cover;" poster="../../assets/img/home/banner.jpg">
              <source :src="item.picturePath" type="video/mp4" >
            </video>
            <a :href="item.picturePath" target="_blank" style="color:#fff;" v-else>
              <img :src="item.picturePath" />
              <div class="banner-text" :style="{textAlign : item.picArea==1?'left' : item.picArea==2?'center' : 'right'}">
                <div class="container" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
                  <h1>{{ item.mainTitle }}</h1>
                  <p>{{ item.subTitle }}</p>
                </div>
              </div>
            </a>
          </el-carousel-item>
        </el-carousel>
        <div class="banner-bottom">
          <div class="col" v-for="(item,index) in $t('home.banner.businessScope')" :key="index">
            <router-link :to="item.src">
              <i :style="`background: url(${item.icon}) no-repeat;`"></i>
              <p>{{item.title}}</p>
            </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide company" data-swiper-parallax="-23%" data-swiper-parallax-duration="3000">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.company.headlineTitle")}}</h1>
            <p>{{$t("home.company.headlineP")}}</p>
          </div>

          <el-row :gutter="30">
            <el-col :span="16" class="hidden-xs-only">
              <div class="map">
                <img src="../../assets/img/home/map.png" />
                <div class="country Canada">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Canada")}}
                </div>
                <div class="country USA">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.USA")}}
                </div>
                <div class="country Colombia">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Colombia")}}
                </div>
                <div class="country Brazil">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Brazil")}}
                </div>
                <div class="country Chile">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Chile")}}
                </div>
                <div class="country Argentina">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Argentina")}}
                </div>
                <div class="country Germany">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Germany")}}
                </div>
                <div class="country Romania">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Romania")}}
                </div>
                <div class="country Turkey">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Turkey")}}
                </div>
                <div class="country Egypt">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Egypt")}}
                </div>
                <div class="country Saudi_Arabia">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Saudi_Arabia")}}
                </div>
                <div class="country Kazakhstan">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Kazakhstan")}}
                </div>
                <div class="country Turkmenistan">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Turkmenistan")}}
                </div>
                <div class="country Dubai">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Dubai")}}
                </div>
                <div class="country India">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.India")}}
                </div>
                <!-- <div class="country Russia">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Russia")}}
                </div> -->
                <div class="country China">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.China")}}
                </div>
                <div class="country Taiwan">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Taiwan")}}
                </div>
                <div class="country Malaysia">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Malaysia")}}
                </div>
                <div class="country Korea">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Korea")}}
                </div>
                <div class="country Japan">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Japan")}}
                </div>
                <div class="country Philippines">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Philippines")}}
                </div>
                <div class="country Indonesia">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Indonesia")}}
                </div>
                <div class="country Sydney">
                  <span>
                    <span></span>
                  </span>
                  {{$t("home.company.map.Sydney")}}
                </div>
              </div>
            </el-col>
            <el-col :span="8" :xs="24">
              <div data-swiper-parallax="-300" data-swiper-parallax-duration="600">
                <h2>
                  <span class="company-name">{{$t("home.company.companyName")}}</span>
                  <span class="line">__</span>
                  <span class="name-tag">{{$t("home.company.nameTag")}}</span>
                </h2>
                <p class="introduce" v-for="(item,index) in introduce" :key="index">{{item}}</p>
                <div class="more">
                  <router-link to="/about">
                    <p>{{$t("home.company.more")}}</p>
                    <img src="../../assets/img/home/arrow.png" />
                  </router-link>
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="company-num">
            <el-row>
              <el-col
                :span="6"
                v-for=" (item,index) in $t('home.company.companyNumber')"
                :key="index"
                class="num-col"
              >
                <div>
                  <ICountUp
                    :delay="delay"
                    :endVal="item.title"
                    :options="iCountUpOptions"
                    @ready="onReady"
                    v-if="numScroll"
                    class="num"
                  />
                  <p>{{item.detail}}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide business-layout" >
        <div class="container">
          <div class="headline">
            <h1 style="color:#fff;">{{$t("home.businessLayout.headlineTitle")}}</h1>
            <p>{{$t("home.businessLayout.headlineP")}}</p>
          </div>
          <div class="banner-bottom">
            <div class="col" v-for="(item,index) in $t('home.banner.businessScope')" :key="index" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <router-link :to="item.src">
                <i :style="`background: url(${item.icon}) no-repeat;`"></i>
                <h2>{{item.title}}</h2>
                <p>{{item.des}}</p>
                <div class="mark">
                  <i :style="`background: url(${item.icon}) no-repeat;`"></i>
                  <h2>{{item.title}}</h2>
                  <ul v-html="item.businessSlide"></ul>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide product">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.product.headlineTitle")}}</h1>
            <p>{{$t("home.product.headlineP")}}</p>
          </div>
          <el-carousel trigger="click" indicator-position="none" :autoplay="false" arrow="always" data-swiper-parallax-x="-300" data-swiper-parallax-duration="1000">
            <el-carousel-item v-for="(item,index) in $t('home.product.res')" :key="index">
              <el-row :gutter="60">
                <el-col :span="16" class="prodect-des" >
                  <div class="box">
                    <h2>
                      {{item.title}}
                      <span>{{item.titleEn}}</span>
                    </h2>
                    <p>{{item.des}}</p>
                    <router-link :to="item.src" class="link"><el-button type="primary" plain round >{{$t("home.product.button")}}</el-button></router-link>
                  </div>
                </el-col>
                <el-col :span="8" >
                  <img :src="item.pic" />
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide news">
        <div class="container">
          <div class="news-box">
            <div class="headline">
              <h1>{{$t("home.news.headlineTitle")}}</h1>
              <p>{{$t("home.news.headlineP")}}</p>
            </div>
       
            <el-row :gutter="40" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <el-col :span="18">
                <div  class="new-des" @click="toNewsDetail(newsInfo)">
                  <img :src="newsInfo.mainPicUrl" alt />
                  <div class="mark">
                    <h2>{{ newsInfo.title }}</h2>
                    <p>{{ newsInfo.createTime }}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="lists-wrap">
                  <router-link to="/news" class="more">
                    <p>{{$t("home.company.more")}}</p>
                    <img src="../../assets/img/home/arrow.png" />
                  </router-link>
                  
                  <ul class="lists">
                    <li
                      v-for="(item,index) in topNews"
                      :key="index"
                      @click="toNewsDetail(item)"
                      @mouseover="getNewsIndex(index)"
                      class="list"
                    >
                      <img :src="item.mainPicUrl" alt class="pic" />
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
           
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide partner">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.partner.headlineTitle")}}</h1>
            <p>{{$t("home.partner.headlineP")}}</p>
          </div>
          <div class="swiper-box">
            <swiper :options="partnerOption" >
              <swiper-slide class="swiper-slide">
                <img src="../../assets/img/home/enterprise1.png" alt="">
              </swiper-slide>
              <swiper-slide class="swiper-slide">
                <img src="../../assets/img/home/enterprise2.png" alt="">
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <footer class="footer">
          <div class="contact-footer">
            <div class="container">
              <el-row>
                <el-col :span="18" :xs="24">
                  <ul class="address">
                    <li class="contact">
                      {{$t("contact.banner.bannerTitle")}}
                    </li>
                    <li>
                      <div><i class="el-icon-phone mr10"></i><span v-html="$t('foot.Phone')"></span></div>
                    </li>
                    <li>
                      <div>
                        <i class="el-icon-phone-outline mr10"></i>
                        <span v-html="$t('foot.tel')"></span>
                        <span class="recruit-item">{{$t("foot.RecruitTel")}}</span>
                      </div>
                    </li>
                    <li>
                      <div><i class="el-icon-location-outline mr10"></i>{{$t("foot.Address")}}</div>
                    </li>
                    <li>
                      <div>
                        <i class="el-icon-message mr10"></i>
                        <span v-html="$t('foot.Email')"></span>
                        <span class="recruit-item">{{$t("foot.RecruitEmail")}}</span>
                      </div>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6" :xs="24" class="pic-row">
                  <div class="box">
                    <img src="../../assets/img/base/gzh.png" class="teg-img" />
                    <p>{{$t("contact.wxName")}}</p>
                  </div>
                  <div class="box">
                    <img src="../../assets/img/base/douying.png" class="teg-img" />
                    <p>{{$t("contact.dyName")}}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="copyright">
            <div class="container">
              <span>Copyright 2025 ©大庆高新国际工贸集团 </span>
              <span class="mr20">
                <a href="https://beian.miit.gov.cn" target="_blank">黑ICP备2021006543号-1</a>
                <a
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044151"
                  target="_blank"
                >
                  <i class="police "></i>京公网安备 11010502044151号
                </a>
              </span>
              <span>*网站内所有统计数据均包含子公司</span>
            </div>
          </div>
        </footer>
      </swiper-slide>
      <div class="hidden-xs-only" id="float-logo" ref="floatLogo" @mouseover="handleLogoOver" @mouseout="handleLogoOut" v-show="logoIsShow">
        <router-link :to="{path:'/year20'}"><img src="../../assets/img/base/banner-logo.png" alt=""></router-link>
        <i class="el-icon-error" @click="handleLogoClear"></i>
      </div>
    </swiper>

    <div class="hidden-sm-and-up">
      <div class="banner">
        <el-carousel trigger="click" indicator-position="none" autoplay>
          <el-carousel-item >
            <router-link :to="{path:'/year20'}"  >
              <img src="../../assets/img/year20/banner20.jpg" />
              <div class="banner-text">
                <div class="container" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
                  <div class="banner-btn">
                    <el-button type="primary" plain>{{$t("home.banner.year20")}}</el-button>
                  </div>
                </div>
              </div>
            </router-link>
          </el-carousel-item>
          <el-carousel-item v-for="(item,index) in bannerLists" :key="index">
            <!-- muted：静音播放视频。 playsinline属性则用于防止视频在移动设备上全屏播放-->
            <video width="100%" height="100%" preload="metadata" autoplay muted playsinline loop v-if="item.picturePath.slice(item.picturePath.length-4)=='.mp4'" style="object-fit:cover;" poster="../../assets/img/home/banner.jpg">
              <source :src="item.picturePath" type="video/mp4" >
            </video>
            <a :href="item.picturePath" target="_blank" style="color:#fff;" v-else>
              <img :src="item.picturePath" />
              <div class="banner-text" :style="{textAlign : item.picArea==1?'left' : item.picArea==2?'center' : 'right'}">
                <div class="container" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
                  <h1>{{ item.mainTitle }}</h1>
                  <p>{{ item.subTitle }}</p>
                </div>
              </div>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="company">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.company.headlineTitle")}}</h1>
            <p>{{$t("home.company.headlineP")}}</p>
          </div>
          <el-row >
            <el-col :xs="24">
              <div data-swiper-parallax="-300" data-swiper-parallax-duration="600">
                <h2>
                  <span class="company-name">{{$t("home.company.companyName")}}</span>
                  <span class="line">__</span>
                  <span class="name-tag">{{$t("home.company.nameTag")}}</span>
                </h2>
                <p class="introduce" v-for="(item,index) in introduce" :key="index">{{item}}</p>
                <div class="more">
                  <router-link to="/about">
                    <p>{{$t("home.company.more")}}</p>
                    <img src="../../assets/img/home/arrow.png" />
                  </router-link>
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="company-num">
            <el-row>
              <el-col
                :xs="24"
                v-for=" (item,index) in $t('home.company.companyNumber')"
                :key="index"
                class="num-col"
              >
                <div>
                  <h3>{{item.title}}</h3>
                  <p>{{item.detail}}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="business-layout">
        <div class="container">
          <div class="headline">
            <h1 style="color:#fff;">{{$t("home.businessLayout.headlineTitle")}}</h1>
            <p>{{$t("home.businessLayout.headlineP")}}</p>
          </div>
          <div class="banner-bottom">
            <div class="col" v-for="(item,index) in $t('home.banner.businessScope')" :key="index" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <router-link :to="item.src">
                <i :style="`background: url(${item.icon}) no-repeat;`"></i>
                <h2>{{item.title}}</h2>
                <p>{{item.des}}</p>
                <ul v-html="item.businessSlide"></ul>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="product">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.product.headlineTitle")}}</h1>
            <p>{{$t("home.product.headlineP")}}</p>
          </div>

          <div class="product-list">
            <div class="prodect-des" v-for="(item,index) in $t('home.product.res')" :key="index">
              <h2>
                {{item.title}}
                <span>{{item.titleEn}}</span>
              </h2>
              <p>{{item.des}}</p>
              <img :src="item.pic" />
              <div class="link-row">
                <router-link :to="item.src" class="link"><el-button type="primary" plain round >{{$t("home.product.button")}}</el-button></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="news">
        <div class="container">
          <div class="news-box">
            <div class="headline">
              <h1>{{$t("home.news.headlineTitle")}}</h1>
              <p>{{$t("home.news.headlineP")}}</p>
            </div>
            <el-row :gutter="20" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <el-col :span="18">
                <div  class="new-des" @click="toNewsDetail(newsInfo)">
                  <img :src="newsInfo.mainPicUrl" alt />
                  <div class="mark">
                    <h2>{{ newsInfo.title }}</h2>
                    <p>{{ newsInfo.createTime }}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="lists-wrap">
                  <router-link to="/news" class="more">
                    <p>{{$t("home.company.more")}}</p>
                    <img src="../../assets/img/home/arrow.png" />
                  </router-link>
                  
                  <ul class="lists">
                    <li
                      v-for="(item,index) in topNews"
                      :key="index"
                      @click="toNewsDetail(item)"
                      @mouseover="getNewsIndex(index)"
                      class="list"
                    >
                      <img :src="item.mainPicUrl" alt class="pic" />
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="partner">
        <div class="container">
          <div class="headline">
            <h1>{{$t("home.partner.headlineTitle")}}</h1>
            <p>{{$t("home.partner.headlineP")}}</p>
          </div>
          <div class="swiper-box">
            <swiper :options="partnerOption" >
              <swiper-slide class="swiper-slide">
                <img src="../../assets/img/home/enterprise1.png" alt="">
              </swiper-slide>
              <swiper-slide class="swiper-slide">
                <img src="../../assets/img/home/enterprise2.png" alt="">
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <footer class="footer">
        <div class="contact-footer">
          <div class="container">
            <el-row>
              <el-col :span="18" :xs="24">
                <ul class="address">
                  <li class="contact">
                    {{$t("contact.banner.bannerTitle")}}
                  </li>
                  <li>
                    <div><i class="el-icon-phone mr10"></i><span v-html="$t('foot.Phone')"></span></div>
                  </li>
                  <li>
                    <div>
                      <i class="el-icon-phone-outline mr10"></i>
                      <span v-html="$t('foot.tel')"></span>
                      <span class="recruit-item">{{$t("foot.RecruitTel")}}</span>
                    </div>
                  </li>
                  <li>
                    <div><i class="el-icon-location-outline mr10"></i>{{$t("foot.Address")}}</div>
                  </li>
                  <li>
                    <div>
                      <i class="el-icon-message mr10"></i>
                      <span v-html="$t('foot.Email')"></span>
                      <span class="recruit-item">{{$t("foot.RecruitEmail")}}</span>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" :xs="24" class="pic-row">
                <div class="box">
                  <img src="../../assets/img/base/gzh.png" class="teg-img" />
                  <p>{{$t("contact.wxName")}}</p>
                </div>
                <div class="box">
                  <img src="../../assets/img/base/douying.png" class="teg-img" />
                  <p>{{$t("contact.dyName")}}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="copyright">
          <div class="container">
            <span>Copyright 2025 ©大庆高新国际工贸集团 </span>
            <span class="mr20">
              <a href="https://beian.miit.gov.cn" target="_blank">黑ICP备2021006543号-1</a>
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044151"
                target="_blank"
              >
                <i class="police "></i>京公网安备 11010502044151号
              </a>
            </span>
            <span>*网站内所有统计数据均包含子公司</span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import dialogContact from "../../components/dialog_contact";
import ICountUp from "vue-countup-v2";
import { gettoppiclist } from "../../api/home"
import { getstaticcontent } from "../../api/about"
import {gettopnewlist} from "../../api/news"
import { mapGetters } from "vuex";
export default {
  name: "Home",
  data() {
    const that = this;
    return {
      bannerLists:[],
      swiperOption: {
        passiveListeners: true, // 确保设置为true
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight , // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        parallax : true,
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.indexSwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === 1) {
          //     console.log(swiper.activeIndex);
          //   }
          // }
        },
        breakpoints: {
          768: {
            height: 200, // 高度设置，占满设备高度
          },
          320: {

          }
        }
      },
      delay: 500,
      iCountUpOptions: {
        startVal: 0,
        duration: 5,
        useEasing: true,
        useGrouping: true,
        separator: "",
        decimal: ".",
        prefix: "",
        suffix: ""
      },
      numScroll: false,
      swiperOptionNews: {
        passiveListeners: true, // 确保设置为true
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: 200, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true, // 该参数设置为true时允许拖动滚动条。
         // dragSize: 50 // 设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
        },
        spaceBetween:20
      },
      partnerOption:{
        observer: true,  //开启动态检查器，监测swiper和slide
        observeParents: true,  //监测Swiper 的祖/父元素
        speed: 10000,//切换速度
        loop:true,//循环
        // slidesPerView:4,//显示数量
        //spaceBetween:0,//间隔
        freeMode:true,//自动贴合
        autoplay: {//自动播放
          delay: 0,//自动切换的时间间隔
          stopOnLastSlide: false,//切换到最后一个slide时停止自动切换
          disableOnInteraction: false,//用户操作后是否停止
        },
        // breakpoints: { 
        //   750: {  //当屏幕宽度大于等于320
        //     slidesPerView: 3,
        //   },
        // }

      },
      introduce:"",
      topNews:[],
      newsInfo:{},
      iSpeedX:6,
      iSpeedY:8,
      timer:0,
      logoIsShow:true
    };
  },
  components: {
    dialogContact,
    ICountUp
  },
  computed:{
    ...mapGetters(['language'])
  },
  mounted() {
    // 首页新闻
    gettopnewlist(this.language).then(res =>{
      if(res.data.length){
        this.topNews=res.data
        this.newsInfo = res.data[0];
      }
    });
    
    gettoppiclist (this.language, "1" ).then(res=>{
      this.bannerLists = res.data;

    });
    this.getCount();

    this.startMove();
    // 获取视频元素
    // const myVideo = document.querySelector('video');
    // // 添加事件监听器
    // document.addEventListener('DOMContentLoaded', function() {
    //  myVideo.addEventListener('click', function() {
    //       if (myVideo.paused) {
    //           myVideo.play(); // 开始播放视频
    //       } else {
    //           myVideo.pause(); // 暂停播放视频
    //       }
    //  });
    // });
  },
  methods: {
    onReady(instance) {
      const that = this;
     // instance.update(that.endVal)
    },
    slideChange() {
      this.$nextTick(()=>{
        let swiperIndex = this.$refs.indexSwiper.swiper.activeIndex;
        if (swiperIndex == 1) {
          this.numScroll = true;
          this.getCount();
        } else {
          this.numScroll = false;
        };
        if(swiperIndex%2){
          this.$store.commit('app/SET_DARKMODE',false);
        }else{
          this.$store.commit('app/SET_DARKMODE',true);
        };
      })
    },
    getCount(){
      getstaticcontent ( this.language,"1" ).then(res=>{
        if(res.data.length){
            this.introduce = res.data[0].smallContent.split("\n");
            this.$set(this.$t('home.company.companyNumber')[0],"title", Number(res.data[0].startYear) );
            this.$set(this.$t('home.company.companyNumber')[1],"title", Number(res.data[0].deptQuantity));
            this.$set(this.$t('home.company.companyNumber')[2],"title", Number(res.data[0].countryQuantity));
            this.$set(this.$t('home.company.companyNumber')[3],"title", Number(res.data[0].userQuantity));
        }
      });
    },
    getNewsIndex(index) {
        this.newsInfo = this.topNews[index];
    },

    setNavIndex(item,key){
      sessionStorage.setItem("activeIndex",key);
      this.$store.commit('app/SET_ACTIVE',key);
      this.$router.push({
        path:item.url,
        query:{part:item.param}
      })
    },

    toNewsDetail(item) {
      if(item.wxUrl){
        window.open(item.wxUrl,false);
      }else{
        this.$router.push({ path: `/news/detail/${item.id}` });
      }
    },
		//logo漂移运动
    startMove(){
      this.$nextTick(()=>{
        let oDiv=this.$refs.floatLogo;

        this.timer=setInterval( ()=>{

          let l=oDiv.offsetLeft+this.iSpeedX;
          let t=oDiv.offsetTop+this.iSpeedY;
          
          if(t>=document.documentElement.clientHeight-oDiv.offsetHeight)
          {
            this.iSpeedY*=-1;
            t=document.documentElement.clientHeight-oDiv.offsetHeight;//把T的值硬性的拉回
          }
          else if(t<=0)//如果小于0，则将其值设置为0，即不允许其超出边
          {
            this.iSpeedY*=-1;
            t=0;
          }
          
          if(l>=document.documentElement.clientWidth-oDiv.offsetWidth)
          {
            this.iSpeedX*=-1;
            l=document.documentElement.clientWidth-oDiv.offsetWidth;//把l的值硬性接回来
          }
          else if(l<=0)//如果小于0，则将其值设置为0，即不允许其超出
          {
            this.iSpeedX*=-1;
            l=0;
          }
          
          oDiv.style.left=l+'px';
          oDiv.style.top=t+'px';
        }, 100);
      })
    },
    handleLogoOver(){
      clearInterval(this.timer);
    },
    handleLogoOut(){
      this.startMove();
    },
    handleLogoClear(){
      clearInterval(this.timer);
      this.logoIsShow=false;
    }
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
  
};
</script>

<style scoped lang="scss">

.home{
  margin-top:-60px;
  .headline {
    padding: 100px 0 40px;
  }
  .banner {
    ::v-deep .el-carousel__container {
     // height: calc(100vh - 60px);
     height: 100vh;
    }

    .banner-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2000;
      width: 100%;
      display: flex;
      padding: 50px 0 40px;
      background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.8));
      .col {
        width: 20%;
        text-align: center;
        a {
          color: #fff;
          display: block;
          transition: all 0.3s;
          &:hover {
            // i{
            //   background-position-y: -40px;
            // }
            // color:#0052AC;
            opacity: 0.8;
            transform: scale(1.2);
          }
          i {
            width: 40px;
            height: 40px;
            display: inline-block;
            overflow: hidden;
            margin-bottom: 10px;
          }
          p{
            font-size:18px;
          }
        }
      }
    }
    a{
      display: block;
      height:100%;
      img{
        width:100%;
        height:100%;
        object-fit: cover;
      }
      .container{
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h1 {
          font-size: 30px;
          margin: 0 0 10px;
        }

      }
    }
    .banner-btn{
      margin-top:20%;
      margin-left:40px;
      // .el-button{
      //   background:transparent;
        
      // }
    }
  }
  .company {
    background:url(../../assets/img/home/introduction_bg.png) no-repeat center/cover;
    .map {
      position: relative;
      font-size: 14px;
      img {
        width: 100%;
      }
      @keyframes country {
        0% {
          opacity: 1;
          transform: scale(1);
        }
        100% {
          opacity: 0;
          transform: scale(6);
        }
      }
      .country {
        position: absolute;
      }
      .country > span {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 5px;
        border-radius: 50%;
        background: #0054a7;
      }
      .country > span > span {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        box-shadow: inset 0 0 3px #0054a7;
        animation: country 3s infinite;
      }
      .Canada {
        left: 15.8%;
        top: 28.8%;
      }
      .USA {
        left: 18%;
        top: 40.5%;
      }
      .Colombia {
        left: 25.4%;
        top: 59.4%;
      }
      .Brazil {
        left: 31.7%;
        top: 69.4%;
      }
      .Chile {
        left: 26.5%;
        top: 82.2%;
      }
      .Argentina {
        left: 27.3%;
        top: 88.3%;
      }
      .Germany {
        left: 48.7%;
        top: 29.4%;
      }
      .Romania {
        left: 52.6%;
        top: 33.8%;
      }
      .Turkey {
        left: 51.2%;
        top: 43.8%;
      }
      .Egypt {
        left: 52.6%;
        top: 50%;
      }
      .Saudi_Arabia {
        left: 59%;
        top: 52.5%;
      }
      .Kazakhstan {
        left: 64.3%;
        top: 36.6%;
      }
      .Turkmenistan {
        left: 62.4%;
        top: 41%;
      }
      .Dubai {
        left: 62.1%;
        top: 48.2%;
      }
      .India {
        left: 68.2%;
        top: 50%;
      }
      .Russia {
        left: 75%;
        top: 18.8%;
      }
      .China {
        left: 79%;
        top: 35%;
        color: #d81e06;
      }
      .Taiwan {
        left: 80%;
        top: 49%;
      }
      .Malaysia {
        left: 75%;
        top: 59%;
      }
      .Korea {
        left: 82.1%;
        top: 38.8%;
      }
      .Japan {
        left: 84%;
        top: 43%;
      }
      .Philippines {
        left: 80%;
        top: 54%;
      }
      .Indonesia {
        left: 81%;
        top: 63%;
      }
      .Sydney {
        left: 88.4%;
        top: 81.6%;
      }
    }
    h2 {
      position: relative;
      margin-bottom: 30px;
      font-weight: bold;
      .company-name {
        color: #000;
        font-size: 30px;
      }
      .line {
        color: #0052ac;
      }
      .name-tag {
        position: absolute;
        right: 0;
        top: -16px;
        color: #d5d5d5;
        font-size: 28px;
        z-index: -1;
      }
    }
    .introduce {
      line-height: 2;
      text-align: justify;
    }
    .more {
      text-align: right;
      a {
        font-size: 20px;
        color: #000;
        p {
          position: relative;
          right: 30px;
          top: 10px;
        }
      }
    }
    .company-num {
      color: #0052ac;
      text-align: center;
      .num-col {
        & + .num-col {
          border-left: 1px solid #0052ac;
        }
        .num {
          font-size: 50px;
          font-weight: bold;
        }
      }
    }
  }
  .business-layout {
    background: url(../../assets/img/home/business_bg.jpg) no-repeat center/cover;
    .banner-bottom {
      width: 100%;
      display: flex;
      .col {
        width: 20%;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
        height: 540px;
        border-right: 2px solid rgba(256, 256, 256, 0.1);

        a {
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          position: relative;
          overflow: hidden;
          i {
            width: 40px;
            height: 40px;
            display: block;
            overflow: hidden;
            margin: 0 auto 20px;
          }
          h2 {
            margin-bottom: 10px;
          }
          .mark {
            position: absolute;
            left: 0;
            top: 100%;
            width: 100%;
            height: 100%;
            background: rgba(0, 84, 167, 0.6);
            color: #fff;
            transition: all 0.4s;
            box-sizing: border-box;
            padding: 40px 20px 20px;
            ul {
              line-height: 2;
              // transform:translateX(50%);
              // margin-left: -50%;
              ::v-deep li{
                list-style: circle;
                text-align: left;
                margin-left:20px;
              }
            }
          }
          &:hover > i,
          &:hover > h2,
          &:hover > p {
            display: none;
          }
          &:hover .mark {
            top: 0;
          }
        }
      }
    }
  }
  .product {
    background:url(../../assets/img/home/main_product_bg.png) no-repeat center/cover;
    .headline {
      margin-bottom: 100px;
    }
    .prodect-des {
      padding-right:40px;
      .box{
        padding-right:40px;
      }
      h2 {
        color: #0052ac;
        font-size: 40px;
        font-weight: 800;
        margin-bottom: 20px;
        span {
          font-size: 20px;
          margin-left: 20px;
        }
      }
      p{
        text-align: justify;
      }
      .link {
        margin-top: 70px;
        display: inline-block;
      }
    }
    img{
      max-width: 90%;
    }
    ::v-deep .el-carousel__container{
      height:460px;
    }
    ::v-deep .el-carousel__arrow {
      top: 100%;
      transform: translateY(-100%);
    }
    ::v-deep .el-carousel__arrow--left {
      left: auto;
      right: 72px;
    }
  }
  .news {
    background: url(../../assets/img/home/news_bg.jpg) no-repeat center/cover;
    color: #fff;
    .news-box{
      width:90%;
      margin:0 auto;

      .new-des {
        position: relative;
        img {
          height: 560px;
          width: 100%;
          object-fit: cover;
          border-radius: 20px;
        }
        .mark {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          box-sizing: border-box;
          padding: 15px;
          border-radius: 0 0 20px 20px;
          h2{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .lists-wrap{
        position: relative;
        .more{
          position: absolute;
          right:0;
          top:-80px;
          color:#fff;
          font-size: 20px;
          p {
            position: relative;
            top: 15px;
            left:15px;
          }
        }
        .lists {
          height: 560px;
          overflow: hidden;
          box-sizing: border-box;
          .list {
            margin-bottom: 20px;
            .pic {
              height: 170px;
              width: 100%;
              object-fit: cover;
              border-radius: 20px;
            }
          }
        }
      }
    }

  }
  .partner{
    position: relative;
    background:url(../../assets/img/home/enterprise_bg.png);
    .headline{
      padding: 100px 0 20px;
    }
    .swiper-box{
      width:70%;
      margin:0 auto;
      .swiper-container-free-mode>.swiper-wrapper{
        -webkit-transition-timing-function:linear !important; 
        -o-transition-timing-function:linear !important;
        transition-timing-function:linear !important; 
      }
      .swiper-slide{
        img{
          height:100%;
        }
      }
    }
    
    .footer{
      position: absolute;
      left:0;
      bottom:0;
      width:100%;
      margin-top:0;
    }
  }
  #swiperBox{
    position: relative;
    #float-logo {
      position: absolute;
      z-index: 2000;
      i{
        position:absolute;
        right:0;
        top:0;
        font-size:30px;
        color:rgba(255,255,255,.8);
        display: none;
      }
      &:hover{
        i{
          display: block;
        }
      }
    }
  }

  @media screen and (max-width:1200px){
    .news{
      .news-box{
        width:100%;
      }
    }
    .partner{
      .swiper-box{
        width:100%;
      }
    }
  }
  @media screen and (max-width:768px){
    .banner {
      padding-top: 60px;
      ::v-deep .el-carousel__container {
        height: 200px;
      }
    }
    .headline {
      padding: 50px 0 20px;
    }
    .company{
      .more {
        margin: 0px 0 40px;
      }
      h2 {
        margin-bottom: 20px;
        .company-name {
          color: #000;
          font-size: 22px;
        }
        .name-tag {
          font-size: 20px;
        }
      }
      .company-num {
        color: #0052ac;
        text-align: center;
        margin-bottom: 40px;
        .num-col {
          border: 1px solid #0052ac;
          height: 100%;
          .num {
            font-size: 50px;
            font-weight: bold;
          }
        }
      }
    }
    .business-layout{
      .banner-bottom {
        width: 100%;
        display: flex;
        flex-direction: column;
        .col {
          width: 100%;
          background: rgba(0, 0, 0, 0.5);
          text-align: center;
          height: auto;
          border-right: 2px solid rgba(256, 256, 256, 0.1);
          margin-bottom:20px;
          padding: 40px 0;
          a {
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            position: relative;
            overflow: hidden;
            i {
              width: 40px;
              height: 40px;
              display: block;
              overflow: hidden;
              margin: 0 auto 20px;
            }
            h2 {
              margin-bottom: 20px;
            }
            p{
              margin-bottom: 20px;
            }
            &:hover > i,
            &:hover > h2,
            &:hover > p {
              display: block;
            }
          }
        }
      }
    }
    .product {
      .headline {
        margin-bottom: 0px;
      }
      .prodect-des {
        padding-bottom: 40px;
        h2 {
          color: #0052ac;
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 20px;
          span {
            font-size: 16px;
            margin-left: 20px;
          }
        }
        p{
          text-align: justify;
          margin-bottom: 10px;
        }
        .link-row{
          text-align: right;
          .link {
            margin-top: 0;
            display: inline-block;
          }
        }
        
      }
      
      ::v-deep .el-carousel__container{
        height:600px;
      }
      ::v-deep .el-carousel__arrow {
        top: 100%;
        transform: translateY(-150%);
      }
      ::v-deep .el-carousel__arrow--left {
        left: auto;
        right: 72px;
      }
    }
    .news {
      padding-bottom:40px;
      .news-box{
        width:100%;
        .new-des {
          img {
            height: 220px;
            width: 100%;
            object-fit: cover;
            border-radius: 20px;
          }
          .mark {
            h2{
              font-size: 14px;
            }
          }
        }
        .lists-wrap{
          .more{
            // top:-80px;
            font-size: 14px;
          }
          .lists {
            height: 220px;
            overflow: hidden;
            box-sizing: border-box;
            .list {
              margin-bottom: 20px;
              .pic {
                height: 60px;
                width: 100%;
                object-fit: cover;
                border-radius: 5px;
              }
            }
          }
        }
        
      }
      
    }
    .partner{
      .headline{
        padding: 50px 0 20px;
      }
      .swiper-box{
        width:100%;
        .swiper-slide{
          img{
            height:auto;
          }
        }
      }
    }
  }
}
</style>
